import src from "IMAGE";
export default { src, width: 48, height: 48, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAL0lEQVR42p2PMQoAAAgC+/+3/JVLUVNDYCXc5IFoLmIngWQxClkAKLq0F+TE+0UA0dP7uSGbi6EAAAAASUVORK5CYII="};
